
import { defineComponent } from 'vue';
import { IonPage, IonContent, } from '@ionic/vue';
export default defineComponent({
    name: 'Fullscreen Layout',
    components: {
        IonContent,
        IonPage,
    },
    setup() {
        return {

        }
    },
})
